/**
 * Singleton class for all Global actions (TrackActions)
 */

import isEmpty from 'lodash/isEmpty';
import {action, observable} from 'mobx';

class ActionStore {
    @observable sessionActions = [];
    @observable sessionIndex = 0;
    @observable waterMark = 0;
    @observable minUndoLength = 0;
    @observable isDirty = false;


    @action add(action) {
        if (isEmpty(action) || isEmpty(action.id)) {
            throw new Error('missing identifier please set id');
        }
        this.isDirty = true;
        this.sessionActions[this.sessionIndex] = action;
        this.sessionIndex += 1;
        this.waterMark += 1;
    }

    @action setIsDirty = (isDirty) => {
        this.isDirty = isDirty;
    };

    @action setMinUndoLength(actionNum) {
        this.minUndoLength = actionNum;
    }

    @action getNextAction() {
        if (this.hasNextAction()) {
            const action = this.getActiveAction();
            this.sessionIndex += 1;
            return action;
        }
        return null;
    }

    hasNextAction() {
        return this.sessionIndex < this.waterMark;
    }

    hasPrevAction() {
        return this.sessionIndex > 0 && this.sessionIndex > this.minUndoLength;
    }

    @action removeLastAction() {
        if (this.hasPrevAction()) {
            this.sessionIndex -= 1;
            if (this.sessionIndex === this.minUndoLength) {
                this.isDirty = false;
            }
            return this.getActiveAction();
        }
        return null;
    }

    isEmpty() {
        return this.waterMark === 0;
    }

    getActiveAction() {
        return this.sessionActions[this.sessionIndex];
    }

    get(actionID) {
        if (this.actions.has(actionID)) {
            return this.actions.get(actionID);
        }
        return null;
    }

    getAll() {
        if (!this.isEmpty()) {
            return this.sessionActions.slice(0, this.sessionIndex);
        }
        return [];
    }

    getByTrackId(trackId, withGlobals) {
        const allActions = this.getAll();
        let res = allActions.filter(action => action.trackId === trackId);
        if (withGlobals) {
            res = res.concat(allActions.filter(action => action.trackId === 'global'));
        }
        return res.sort((a, b) => a.created - b.created);
    }

    @action removeByTrackId(trackId) {
        const minUndoLength = this.minUndoLength;
        const sessionIndex = this.sessionIndex;
        const sessionActions = this.sessionActions.slice();

        this.init();

        for (let i = 0; i < sessionActions.length; i++) {
            if (i < sessionIndex) {
                let action = sessionActions[i];
                if (action.trackId !== trackId) {
                    this.add(sessionActions[i]);
                }
            }
        }
        this.minUndoLength = minUndoLength;
    }

    init() {
        this.sessionActions.replace([]);
        this.sessionIndex = 0;
        this.waterMark = 0;
        this.minUndoLength = 0;
        this.isDirty = false;
    }
}

const actionStore = new ActionStore();
export default actionStore;
